module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "topcoat-checkbox"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.checkboxName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topcoat-checkbox__checkmark",
    class: {
      'is-danger': _vm.errors.has(_vm.checkboxName)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.checkboxName)),
      expression: "errors.has(checkboxName)"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n\t\t\tX\n\t\t")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32698206!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkbox.vue
// module id = 113
// module chunks = 2